export default __webpack_public_path__ + "static/media/12.691141d1.png";